import React, { Fragment } from 'react'
import { FormInput } from '@myxplor/forms'
import { hasNestedErrors } from '../../../io/error-handling'
import { hintText, labelFromName } from './helpers'

const GovActionErrorForm = ({ title, errors = {}, onChange, basePath = '' }) => (
  <Fragment>
    {title && <legend>{title}</legend>}
    {Object.keys(errors).map((error, i) => (
      <GovActionErrorInput
        key={'errorInput' + i}
        name={error}
        errors={errors[error]}
        onChange={onChange}
        basePath={basePath}
      />
    ))}
  </Fragment>
)

const GovActionErrorInput = ({ name, errors, onChange, basePath }) =>
  hasNestedErrors(errors) ? (
    <GovActionErrorForm
      title={name}
      errors={errors}
      onChange={onChange}
      basePath={basePath + name + '.'}
    />
  ) : (
    <FormInput
      required
      name={basePath + name}
      label={labelFromName(name)}
      onChange={onChange}
      hint={hintText(errors)}
    />
  )

export default GovActionErrorForm



// WEBPACK FOOTER //
// ./src/ui/forms/form-from-errors/form.jsx